import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add Bearer token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('wid-token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

export const clientsAPI = {
  getAll: () => api.get('/clients'),
  getOne: (id) => api.get(`/clients/${id}`),
  create: (data) => api.post('/clients', data),
  update: (id, data) => api.put(`/clients/${id}`, data),
  delete: (id) => api.delete(`/clients/${id}`),
  getHistory: (id) => api.get(`/clients/${id}/history`),
  getStatusHistory: (id) => api.get(`/clients/${id}/status-history`),
};

export const monitoringAPI = {
  getJournal: (params) => api.get('/monitoring/journal', { params }),
};

export const statusAPI = {
  getAll: () => api.get('/statuses'),
};

export const triggersAPI = {
  getAll: () => api.get('/triggers'),
  create: (data) => api.post('/triggers', data),
  update: (id, data) => api.put(`/triggers/${id}`, data),
  delete: (id) => api.delete(`/triggers/${id}`),
};

export const templatesAPI = {
  getAll: () => api.get('/templates'),
  create: (data) => api.post('/templates', data),
  update: (id, data) => api.put(`/templates/${id}`, data),
  delete: (id) => api.delete(`/templates/${id}`),
};

export const logsAPI = {
  getActions: () => api.get('/logs/actions'),
  getSync: () => api.get('/logs/sync'),
};

export const syncAPI = {
  syncGoogleSheets: () => api.post('/sync/google-sheets'),
};

export const testAPI = {
  sendSMS: (data) => api.post('/send-test-sms', data),
  sendEmail: (data) => api.post('/send-test-email', data),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
};

export default api;